/**
 * Shared layout contract for the embedded invite list. Kept in its own module (rather than
 * inside a component) because more than one feature depends on these heights — the invite list
 * itself and the counter-jobs empty state (CandidatesEmpty) — so a leaf component is the wrong
 * home for them.
 */

/** Full height of the embedded invite list. */
export const LIST_MAX_HEIGHT = 420;

/** Reduced list height used while the invite UI is payment-locked (GOTU-4421). */
export const COMPACT_LIST_MAX_HEIGHT = 180;
